import { color, Link, media, radius, spacing, typography } from '@gyym/ui'
import styled from 'styled-components'

export const SwiperContainer = styled.div`
  margin: 0 auto;
  width: 100%;

  ${media.pc} {
    max-width: 752px;
  }

  & .swiper-container {
    padding: 0 ${spacing(8)};

    ${media.pc} {
      padding: 0 ${spacing(3)};
    }
  }
`

export const ActivityChip = styled(Link)`
  ${typography('subhead1')};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color('white')};
  height: 170px;
  min-width: 170px;
  width: 100%;
  border-radius: ${radius('lg')};
  border: 4px solid ${color('white')};
  box-sizing: border-box;
  box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.1);
  text-shadow: rgba(0, 0, 0, 0.9) 0px 3px 9px;
  position: relative;
  overflow: hidden;

  & > span {
    position: absolute;
    z-index: 10;
  }
`
